module.exports = __webpack_public_path__ + "img/mind_skeleton_15.ecb4ca8a.png";